import { Component } from '@angular/core';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    standalone: false
})
export class SignoutComponent { }

// Keep this class here to prevent console errors
